"use client"
import React, {useState} from 'react';
import {InputBase} from '@mui/material';
import {useTranslations} from "use-intl";
import {MenuBuilderShortcutModel, MenuBuilderWidgetModel} from "@/core/model/main.model";
import {Column} from "@/core/general/column.component";
import {Row} from "@/core/general/row.component";
import {BackIconComponent} from "@/core/general/backIcon.component";
import SearchComponent from "@/core/widget/searchWidget.component";
import {router} from "next/client";
import {useRouter} from "next/navigation";

interface WidgetProps {
  widget: MenuBuilderWidgetModel;
}

export default function SearchShortcutComponent(props:WidgetProps) {
  const t = useTranslations();
  const router = useRouter();
  const [searchText, setSearchText] = useState('');
  const [searchShortcutReserveList, setSearchShortcutReserveList] = useState<MenuBuilderWidgetModel>(props.widget);
  const [searchShortcutList, setSearchShortcutList] = useState<MenuBuilderWidgetModel>(props.widget);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.currentTarget.value);
    setSearchShortcutList(checkShortcutListIncludeSearchString(searchShortcutReserveList, event.currentTarget.value));
  };

  const checkShortcutListIncludeSearchString = (
      array: MenuBuilderWidgetModel,
      searchText: string
  ): MenuBuilderWidgetModel => {
    if (array) {
      const widget = {} as MenuBuilderWidgetModel;
      const shortcuts: MenuBuilderShortcutModel[] = [];
      const shNameArray: MenuBuilderShortcutModel[] = [];
      array.shortcuts.forEach((item) => {
        if (item.title) {
          shNameArray.push(item);
        } else {
          item.title = {
            fa: t(`shName.${item.unique_name}`),
            en: t(`shName.${item.unique_name}`)
          };
          shNameArray.push(item);
        }
      });
      shNameArray.forEach((shortcut) => {
        if (shortcut?.title?.fa?.toLowerCase().includes(searchText.toLowerCase())) {
          shortcuts.push(shortcut);
        } else if (shortcut?.title?.en?.toLowerCase().includes(searchText.toLowerCase())) {
          shortcuts.push(shortcut);
        }
        return '';
      });
      widget.shortcuts = shortcuts;
      return widget;
    }
    return array;
  };

  return (
    <div className="fullWidth background z-50">
      <Column className="totalCenter w-full">
        <Row className="sticky top-0 p-1 items-center backgroundCard z-10 w-full">
          <div className="grow p-1 mt-2 mx-3 toolbarSearchFrame flex flex-row items-center">
            <BackIconComponent
              onClick={() => router.back()}
            />
            <InputBase
              autoFocus={true}
              value={searchText}
              className="grow input-group ms-1 me-3 mText font"
              placeholder={t('searchTool')}
              onChange={handleChange}
            />
          </div>
        </Row>
        <Column className="mt-1 pt-1 px-1 background totalCenter w-full items-center">
          <SearchComponent widget={searchShortcutList} hasTitle={false} />
        </Column>
      </Column>
    </div>
  );
};
